// Standardized data schemas for all portfolio sections
// Use these classes/objects to ensure consistent data structure

export class SectionHeader {
  constructor(subtitle, title, id) {
    this.subtitle = subtitle;
    this.title = title;
    this.id = id;
  }
}

export class Card {
  constructor(icon, title, subtitle, iconLibrary = 'react-icons/fa') {
    this.icon = icon;
    this.title = title;
    this.subtitle = subtitle;
    this.iconLibrary = iconLibrary;
  }
}

export class SkillItem {
  constructor(name, level, icon = 'BsPatchCheckFill') {
    this.name = name;
    this.level = level;
    this.icon = icon;
  }
}

export class SkillCategory {
  constructor(title, skills, className = 'front') {
    this.title = title;
    this.skills = skills; // Array of SkillItem
    this.className = className;
  }
}

export class ServiceItem {
  constructor(text, icon = 'BsCheck2Circle', className = '') {
    this.text = text;
    this.icon = icon;
    this.className = className;
  }
}

export class Service {
  constructor(title, items) {
    this.title = title;
    this.items = items; // Array of ServiceItem
  }
}

export class PortfolioItem {
  constructor(id, image, title, github, demo, description = '') {
    this.id = id;
    this.image = image;
    this.title = title;
    this.github = github;
    this.demo = demo;
    this.description = description;
  }
}

export class ContactOption {
  constructor(icon, title, subtitle, link, iconLibrary = 'react-icons/bs') {
    this.icon = icon;
    this.title = title;
    this.subtitle = subtitle;
    this.link = link;
    this.iconLibrary = iconLibrary;
  }
}

export class ExperienceItem {
  constructor(title, company, description, icon = 'BsPatchCheckFill', startDate = null, endDate = null, website = null, lat = null, lng = null) {
    this.title = title;
    this.company = company;
    this.description = description;
    this.icon = icon;
    this.startDate = startDate;
    this.endDate = endDate;
    this.website = website;
    this.lat = lat;
    this.lng = lng;
  }
}

export class ConferenceItem {
  constructor(name, date, location = '', url = '', description = '', lat = null, lng = null) {
    this.name = name;
    this.date = date;
    this.location = location;
    this.url = url;
    this.description = description;
    this.lat = lat;
    this.lng = lng;
  }
}

/** Duration string from startDate (YYYY-MM) and optional endDate (YYYY-MM or null = current). */
export function getDurationMonthsYears(startDate, endDate = null) {
  if (!startDate) return '';
  const [sy, sm] = startDate.split('-').map(Number);
  const end = endDate ? endDate.split('-').map(Number) : null;
  const now = new Date();
  const [ey, em] = end ? [end[0], end[1]] : [now.getFullYear(), now.getMonth() + 1];
  let months = (ey - sy) * 12 + (em - sm);
  if (months < 0) months = 0;
  const years = Math.floor(months / 12);
  const remainderMonths = months % 12;
  if (years === 0) return remainderMonths === 0 ? 'Less than 1 month' : `${remainderMonths} month${remainderMonths !== 1 ? 's' : ''}`;
  if (remainderMonths === 0) return `${years} year${years !== 1 ? 's' : ''}`;
  return `${years} year${years !== 1 ? 's' : ''} ${remainderMonths} month${remainderMonths !== 1 ? 's' : ''}`;
}

// Validation helper
export const validateSchema = (data, requiredFields) => {
  return requiredFields.every(field => data.hasOwnProperty(field));
};
